module.exports = __webpack_public_path__ + "static/pic-profile-member-4-5b0e7bd1473179f5e7f98b1525ba95c2.png";